import React, { useState, useEffect } from "react";
import "./counterdown.css"; // Import CSS file for styling

const Countdown = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    function zeroPad(value) {
      return value.toString().padStart(2, "0");
    }

    if (difference > 0) {
      timeLeft = {
        days: zeroPad(Math.floor(difference / (1000 * 60 * 60 * 24))),
        hours: zeroPad(Math.floor((difference / (1000 * 60 * 60)) % 24)),
        minutes: zeroPad(Math.floor((difference / 1000 / 60) % 60)),
        seconds: zeroPad(Math.floor((difference / 1000) % 60)),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <div key={interval}>
        <h3>{timeLeft[interval]}</h3>
        <span>{interval}</span>{" "}
      </div>
    );
  });

  return (
    <div className="countdown">
      {timerComponents.length ? timerComponents : <span>Time's up!</span>}
    </div>
  );
};

export default Countdown;
